import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { AppConfig } from '../app.config';
import { AppSettings } from '../app.settings';
import { Property } from '../models/property';
import { MatSidenavContent } from '@angular/material/sidenav';
import { AppService } from '../app.service';
import { PropertyImage } from '../models/propertyImage';
import { ensureSwiperElements } from '../shared/swiper-register';

@Component({ standalone: false,
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent {
  @ViewChild('sidenav') sidenav:any;
  @ViewChild('sidenavContent', {read: MatSidenavContent}) sidenavContentScrollable?: MatSidenavContent;
  @ViewChild('swiperRef',{ static: false }) swiperRef: ElementRef| undefined;
  public headerFixed: boolean = false;
  public showBackToTop: boolean = false;
  public showNewsletter: boolean = true;
  public showFooter: boolean = true;
  public showToolBarPropertiesSearchBox:boolean = false;
  public scrolledCount = 0;

  //this is for viewing property images in full screen mode
  public propertyImageArray?:PropertyImage[];
  public slideIndex:number=1;

  private breakpointSubscription?:Subscription;
  private routerSubscription?:Subscription;
  private propertImageFullScreenSubscription?:Subscription;
  private changeSize = new Subject<void>();

  readonly breakpoint$;
  private readonly horizontalMenuMinWidth = '(min-width: 1200px)'; // $xl-min

  constructor(private appSettings:AppSettings, private appConfig:AppConfig, private appService:AppService, public router:Router, private breakpointObserver: BreakpointObserver) {
    this.breakpoint$ = this.breakpointObserver
      .observe([this.horizontalMenuMinWidth])
      .pipe(
        distinctUntilChanged()
    );
    this.routerSubscription = router.events.subscribe((val) => {
       if(val instanceof NavigationEnd){
        if (this.sidenavContentScrollable) {
          this.sidenavContentScrollable.scrollTo({top: 0});
        }
       }
    });
  }

  ngAfterViewInit(){
    this.breakpointSubscription=this.breakpoint$.subscribe(() =>
      this.breakpointChanged()
    );

    this.propertImageFullScreenSubscription=this.appService.propertImageFullScreenSubject.subscribe(imageArray =>{
      ensureSwiperElements();
      this.propertyImageArray=imageArray;
    });
    
    document.getElementById('preloader')!.classList.add('hide');
    this.router.events.subscribe(event => {
      if(this.router.url=="/" 
      || this.router.url=="/contact" 
      || this.router.url=="/about" 
      || this.router.url=="/privacy-policy" 
      || this.router.url=="/terms-of-use" 
      || this.router.url=="/accessibility" 
      || this.router.url=="/licensing") this.showNewsletter=false; //temporarily turned off here JN-444
      else this.showNewsletter=false;
      if(this.router.url=="/properties" 
        || this.router.url=="/available" 
        || this.router.url=="/sold") this.showFooter=false;
        else this.showFooter=true;
    });
  }


  public onScroll(event:any){
    this.showToolBarPropertiesSearchBox = (event.target.scrollTop > 250); 
  }

  ngOnDestroy(){
    if(this.breakpointSubscription) this.breakpointSubscription.unsubscribe();
    if(this.routerSubscription) this.routerSubscription.unsubscribe();
    if(this.propertImageFullScreenSubscription) this.propertImageFullScreenSubscription.unsubscribe();
    this.changeSize.complete();
  }

  private breakpointChanged() {
    //the toolbar shows the horizontal menu instead of the sidenav toggle from this width on (hide-gt-lg / hide-lt-xl)
    if(this.breakpointObserver.isMatched(this.horizontalMenuMinWidth)) this.sidenav?.close();
  }

  get settings(){
    return this.appSettings.settings;  
  }

  get businessId(){
    return this.appConfig.businessId;
  }

  get hideScrollbar(){
    return this.appSettings.settings.hideScrollbar;
  }

  public scrollToTop(){
    var scrollDuration = 200;
    var scrollStep = -window.scrollY  / (scrollDuration / 20);
    var scrollInterval = setInterval(()=>{
      if(window.scrollY != 0){
         window.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval); 
      }
    },10);
    if(window.innerWidth <= 768){
      setTimeout(() => { window.scrollTo(0,0) });
    }
  }

  public onSearchItemSelected(p:Property){
    this.router.navigate(['/properties/'+p.id]);
  }

  public closeSidenav(){
    this.sidenav?.close();
  }

  public onSwiperSlideChange($event:any){
    this.slideIndex=this.swiperRef!.nativeElement.swiper.realIndex+1;
  }

  public onSwiperCloseClick(){
    this.propertyImageArray=undefined;
  }
}
